<template>
  <div>
    <b-row>
      <b-col md="6">
        <h1>{{ this.$route.params.name }}</h1>
      </b-col>
      <b-col md="6">
          <router-link to="/geocercas/geocercas"><b-button class="text-right mr-5" variant="success">Regresar a geocercas</b-button></router-link>
      </b-col>
    </b-row>
    <GeofenceMap />
  </div>
</template>
<script>
import GeofenceMap from '../../../components/maps/geofenceMap/GeofenceMap'
export default {
  name: 'viewGeofence',
  components: {
    GeofenceMap,
  },
}
</script>
